import React, { Fragment } from 'react';
import { bool, func, object, string } from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames';

import { IconArrowNavigation } from '../../Icons';
import {
  ModalSwimmy,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from '../../ModalSwimmy';

import css from './SuggestMultiBookingModal.module.css';
import { IconCheckmark, PrimaryButton } from '../../index';
import defaultListingImg from '../../../assets/default-img-listing/default-img-listing.jpg';

const SuggestMultiBookingModal = (props) => {
  const {
    className,
    intl,
    isOpen,
    listingCover,
    listing,
    onCloseModal,
    onManageDisableScrolling,
    onSubmit,
    inProgress,
    updated,
    updateInProgress,
  } = props;
  const headingText = intl.formatMessage({ id: 'SuggestMultiBookingSubTitle' });
  const informationText = intl.formatMessage({ id: 'SuggestMultiBookingDisclaimer' });
  const suggestMultiBookingCTAText = intl.formatMessage({ id: 'SuggestMultiBookingCTA' });
  const bookingWarningMessage = intl.formatMessage({ id: 'bookingAutoCancelInfo' });
  const classes = classNames(css.root, className);
  const content = (
    <Fragment>
      <div className={css.information}>
        <span>{informationText}</span>
      </div>
      <div className={css.listingsPreviewsContainer}>
        <div className={css.listingPreviewContainerSuccess}>
          <img
            src={listingCover ?? defaultListingImg}
            className={css.listingPreviewImage}
          />
          <IconCheckmark rootClassName={css.check} size={'small'}/>
        </div>
        <div className={css.listingPreviewContainer}/>
        <div className={css.listingPreviewContainer}/>
        <div className={css.listingPreviewContainer}/>
        <div className={css.listingPreviewContainer}/>
      </div>
      <div className={css.infoText}>
        <span>{bookingWarningMessage}</span>
      </div>
    </Fragment>
  );

  return (
    <ModalSwimmy
      id="SuggestMultiBookingModal"
      animationType="slideRight"
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <ModalOverlay/>
      <ModalContent
        className={css.modalContent}
        animationType="slideRight"
        show={isOpen}
      >
        <ModalHeader className={css.modalHeader}>
          <button className={css.backButton} onClick={onCloseModal}>
            <IconArrowNavigation direction="left"/>
          </button>
          <h2 className={css.heading}>{headingText}</h2>
          <div className={css.spacer}/>
        </ModalHeader>
        <ModalBody className={css.modalBody}>
          {content}
        </ModalBody>
        <div className={css.footer}>
          <PrimaryButton
            className={css.primaryButton}
            onClick={onSubmit}
            inProgress={inProgress}
            disabled={inProgress}
          >
            {suggestMultiBookingCTAText}
          </PrimaryButton>
          <button
            disabled={inProgress}
            type="button" className={css.clearButton} onClick={onCloseModal}>
            <FormattedMessage id={'Marketplace.close'} />
          </button>
        </div>
      </ModalContent>
    </ModalSwimmy>
  );
};

SuggestMultiBookingModal.defaultProps = {
  className: null,
  listing: null,
};

SuggestMultiBookingModal.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  isMobile: bool.isRequired,
  isOpen: bool.isRequired,
  listing: object,
  onCloseModal: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onSubmit: func.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
};

export default SuggestMultiBookingModal;
